import { DashboardInvestorsPage } from './DashboardInvestorsPage';

export default function InsightsInvestorsPage() {
  return (
    <DashboardInvestorsPage
      suppressEmptyPersonaMessage
      showFavouriteSection={false}
      allowRegeneration={false}
    />
  );
}
